//------------------------------------*\
// #Regex
//------------------------------------*/
/* eslint-disable */

export const REGEX_DATE_FORMAT = /^(\d{2})(\.|-)(\d{2})(\.|-)(\d{4})$/
export const REGEX_MONTH_YEAR = new RegExp('^((0[1-9])|(1[0-2]))[.](([1-2][0-9][0-9][0-9]))$', 'i')
export const REGEX_DATE_FORMAT_REVERSED = /^(\d{4})(\.|-)(\d{2})(\.|-)(\d{2})$/

export const REGEX_PHONE_COUNTRY_CODE = new RegExp('^(([\\+]|[0]{2})([0-9,\\-,(,),A-Z,a-z]{1,10}))$', 'i')
export const REGEX_PHONE_AREA_CODE = new RegExp('^[1-9]{1}[0-9]*$', 'i')
export const REGEX_PHONE_NUMBER = new RegExp('^[0-9]*$', 'i')
export const REGEX_TELEPHONE_NUMBER = new RegExp('^([0-9 \\/+-]+)$')

export const REGEX_NAME = new RegExp('^(?![\\d])[^()\\[\\]{}\\\\*/@:;^~$€%&=+!?#.,§<>|_¥£´`·]*$')
export const REGEX_NUMERIC = new RegExp('^[0-9]*$')

export const REGEX_PENSION_INSURANCE_NUMBER = /^\d{8}[A-Za-z]\d{3}/

export const REGEX_INSURANCE_NUMBER = /^[a-zA-Z]\d{9}$/

export const REGEX_IBAN_CODE = /^([A-Za-z]{2})(\d{2})([A-Za-z\d]+)$/
export const REGEX_IBAN_COUNTRY_CODE = /^[A-Za-z]{2}/
export const REGEX_IBAN: {[key: string]: RegExp} = {
  AL: /^AL(\d{2})(\d{8})([A-Za-z0-9]{16})$/,
  DZ: /^DZ(\d{2})(\d{20})$/,
  AD: /^AD(\d{2})(\d{4})(\d{4})([A-Za-z0-9]{12})$/,
  AO: /^AO(\d{2})(\d{21})$/,
  AT: /^AT(\d{2})(\d{5})(\d{11})$/,
  AZ: /^AZ(\d{2})([A-Z]{4})([A-Za-z0-9]{20})$/,
  BH: /^BH(\d{2})([A-Z]{4})([A-Za-z0-9]{14})$/,
  BE: /^BE(\d{2})(\d{3})(\d{7})(\d{2})$/,
  BJ: /^BJ(\d{2})([A-Z]{1}[0-9]{23})$/,
  BA: /^BA(\d{2})(\d{3})(\d{3})(\d{8})(\d{2})$/,
  BR: /^BR(\d{2})(\d{8})(\d{5})(\d{10})([A-Z]{1})([A-Za-z0-9]{1})$/,
  VG: /^VG(\d{2})([A-Z]{4})(\d{16})$/,
  BG: /^BG(\d{2})([A-Z]{4})(\d{4})(\d{2})([A-Za-z0-9]{8})$/,
  BF: /^BF(\d{2})(\d{23})$/,
  BI: /^BI(\d{2})(\d{12})$/,
  BY: /^BY(\d{2})([A-Za-z0-9]{4})(\d{4})([A-Za-z0-9]{16})$/,
  CM: /^CM(\d{2})(\d{23})$/,
  CV: /^CV(\d{2})(\d{21})$/,
  CF: /^CF(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  TD: /^TD(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  KM: /^KM(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  CG: /^CG(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  CR: /^CR(\d{2})(\d{4})(\d{14})$/,
  CI: /^CI(\d{2})([A-Z]{1})(\d{23})$/,
  HR: /^HR(\d{2})(\d{7})(\d{10})$/,
  CY: /^CY(\d{2})(\d{3})(\d{5})([A-Za-z0-9]{16})$/,
  CZ: /^CZ(\d{2})(\d{4})(\d{6})(\d{10})$/,
  DK: /^DK(\d{2})(\d{4})(\d{9})(\d{1})$/,
  FO: /^FO(\d{2})(\d{4})(\d{9})(\d{1})$/,
  GL: /^GL(\d{2})(\d{4})(\d{9})(\d{1})$/,
  DJ: /^DJ(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  DO: /^DO(\d{2})([A-Za-z0-9]{4})(\d{20})$/,
  EG: /^EG(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  SV: /^SV(\d{2})([A-Za-z0-9]{4})(\d{20})$/,
  GQ: /^GQ(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  EE: /^EE(\d{2})(\d{2})(\d{2})(\d{11})(\d{1})$/,
  FI: /^FI(\d{2})(\d{6})(\d{7})(\d{1})$/,
  AX: /^AX(\d{2})(\d{6})(\d{7})(\d{1})$/,
  FR: /^FR(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  GF: /^GF(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  PF: /^PF(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  TF: /^TF(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  GP: /^GP(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  MQ: /^MQ(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  YT: /^YT(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  NC: /^NC(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  RE: /^RE(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  BL: /^BL(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  MF: /^MF(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  PM: /^PM(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  WF: /^WF(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  GA: /^GA(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  GE: /^GE(\d{2})([A-Z]{2})(\d{16})$/,
  DE: /^DE(\d{2})(\d{8})(\d{10})$/,
  GI: /^GI(\d{2})([A-Z]{4})([A-Za-z0-9]{15})$/,
  GR: /^GR(\d{2})(\d{3})(\d{4})([A-Za-z0-9]{16})$/,
  GT: /^GT(\d{2})([A-Za-z0-9]{4})([A-Za-z0-9]{20})$/,
  GW: /^GW(\d{2})([A-Za-z0-9]{2}\d{2})(\d{4})(\d{11})(\d{2})$/,
  HN: /^HN(\d{2})([A-Za-z]{4})(\d{20})$/,
  HU: /^HU(\d{2})(\d{3})(\d{4})(\d{1})(\d{15})(\d{1})$/,
  IS: /^IS(\d{2})(\d{4})(\d{2})(\d{6})(\d{10})$/,
  AA: /^AA(\d{2})([A-Z0-9]{12})$/,
  IR: /^IR(\d{2})(\d{22})$/,
  IQ: /^IQ(\d{2})([A-Za-z]{4})(\d{3})(\d{12})$/,
  IE: /^IE(\d{2})([A-Z]{4})(\d{6})(\d{8})$/,
  IL: /^IL(\d{2})(\d{3})(\d{3})(\d{13})$/,
  IT: /^IT(\d{2})([A-Z]{1})(\d{5})(\d{5})([A-Za-z0-9]{12})$/,
  JO: /^JO(\d{2})([A-Z]{4})(\d{4})([A-Za-z0-9]{18})$/,
  KZ: /^KZ(\d{2})(\d{3})([A-Za-z0-9]{13})$/,
  XK: /^XK(\d{2})(\d{4})(\d{10})(\d{2})$/,
  KW: /^KW(\d{2})([A-Z]{4})([A-Za-z0-9]{22})$/,
  LV: /^LV(\d{2})([A-Z]{4})([A-Za-z0-9]{13})$/,
  LB: /^LB(\d{2})(\d{4})([A-Za-z0-9]{20})$/,
  LI: /^LI(\d{2})(\d{5})([A-Za-z0-9]{12})$/,
  LT: /^LT(\d{2})(\d{5})(\d{11})$/,
  LU: /^LU(\d{2})(\d{3})([A-Za-z0-9]{13})$/,
  MK: /^MK(\d{2})(\d{3})([A-Za-z0-9]{10})(\d{2})$/,
  MG: /^MG(\d{2})(\d{23})$/,
  ML: /^ML(\d{2})([A-Z]{1})(\d{23})$/,
  MT: /^MT(\d{2})([A-Z]{4})(\d{5})([A-Za-z0-9]{18})$/,
  MR: /^MR(\d{2})(\d{5})(\d{5})(\d{11})(\d{2})$/,
  MU: /^MU(\d{2})([A-Z]{4})(\d{2})(\d{2})(\d{12})(\d{3})([A-Z]{3})$/,
  MD: /^MD(\d{2})([A-Za-z0-9]{20})$/,
  MC: /^MC(\d{2})(\d{5})(\d{5})([A-Za-z0-9]{11})(\d{2})$/,
  ME: /^ME(\d{2})(\d{3})(\d{13})(\d{2})$/,
  MA: /^MA(\d{2})(\d{3})(\d{5})(\d{14})(\d{2})$/,
  MZ: /^MZ(\d{2})(\d{21})$/,
  NL: /^NL(\d{2})([A-Z]{4})(\d{10})$/,
  NI: /^NI(\d{2})([A-Za-z]{4})(\d{24})$/,
  NE: /^NE(\d{2})([A-Za-z]{2}\d{3})(\d{5})(\d{12})(\d{2})$/,
  NO: /^NO(\d{2})(\d{4})(\d{6})(\d{1})$/,
  PK: /^PK(\d{2})([A-Z]{4})([A-Za-z0-9]{16})$/,
  PS: /^PS(\d{2})([A-Z]{4})([A-Za-z0-9]{21})$/,
  PL: /^PL(\d{2})(\d{8})(\d{1,16})$/,
  PT: /^PT(\d{2})(\d{4})(\d{4})(\d{11})(\d{2})$/,
  QA: /^QA(\d{2})([A-Z]{4})(\d{4})([A-Za-z0-9]{17})$/,
  RO: /^RO(\d{2})([A-Z]{4})([A-Za-z0-9]{16})$/,
  LC: /^LC(\d{2})([A-Z]{4})([A-Za-z0-9]{24})$/,
  SM: /^SM(\d{2})([A-Z]{1})(\d{5})(\d{5})([A-Za-z0-9]{12})$/,
  ST: /^ST(\d{2})(\d{8})(\d{11})(\d{2})$/,
  SA: /^SA(\d{2})(\d{2})([A-Za-z0-9]{18})$/,
  SN: /^SN(\d{2})([A-Z]{1})(\d{23})$/,
  RS: /^RS(\d{2})(\d{3})(\d{13})(\d{2})$/,
  SC: /^SC(\d{2})([A-Z]{4})(\d{2})(\d{2})(\d{16})([A-Z]{3})$/,
  SK: /^SK(\d{2})(\d{4})(\d{6})(\d{10})$/,
  SI: /^SI(\d{2})(\d{5})(\d{8})(\d{2})$/,
  ES: /^ES(\d{2})(\d{4})(\d{4})(\d{1})(\d{1})(\d{10})$/,
  SE: /^SE(\d{2})(\d{3})(\d{16})(\d{1})$/,
  CH: /^CH(\d{2})(\d{5})([A-Za-z0-9]{12})$/,
  TL: /^TL(\d{2})(\d{3})(\d{14})(\d{2})$/,
  TG: /^TG(\d{2})([A-Za-z]{2}\d{3})(\d{5})(\d{12})(\d{2})$/,
  TN: /^TN(\d{2})(\d{2})(\d{3})(\d{13})(\d{2})$/,
  TR: /^TR(\d{2})(\d{5})(\d{1})([A-Za-z0-9]{16})$/,
  UA: /^UA(\d{2})(\d{6})([A-Za-z0-9]{19})$/,
  AE: /^AE(\d{2})(\d{3})(\d{16})$/,
  GB: /^GB(\d{2})([A-Z]{4})(\d{6})(\d{8})$/,
}

export const IBAN_LENGTHS: {[key: string]: number} = {
  AL: 28,
  DZ: 24,
  AD: 24,
  AO: 25,
  AT: 20,
  AZ: 28,
  BH: 22,
  BE: 16,
  BJ: 28,
  BA: 20,
  BR: 29,
  VG: 24,
  BG: 22,
  BF: 27,
  BI: 16,
  BY: 28,
  CM: 27,
  CV: 25,
  CF: 27,
  TD: 27,
  KM: 27,
  CG: 27,
  CR: 22,
  CI: 28,
  HR: 21,
  CY: 28,
  CZ: 24,
  DK: 18,
  FO: 18,
  GL: 18,
  DJ: 27,
  DO: 28,
  EG: 27,
  SV: 28,
  GQ: 27,
  EE: 20,
  FI: 18,
  AX: 18,
  FR: 27,
  GF: 27,
  PF: 27,
  TF: 27,
  GP: 27,
  MQ: 27,
  YT: 27,
  NC: 27,
  RE: 27,
  BL: 27,
  MF: 27,
  PM: 27,
  WF: 27,
  GA: 27,
  GE: 22,
  DE: 22,
  GI: 23,
  GR: 27,
  GT: 28,
  GW: 25,
  HN: 28,
  HU: 28,
  IS: 26,
  AA: 16,
  IR: 26,
  IQ: 23,
  IE: 22,
  IL: 23,
  IT: 27,
  JO: 30,
  KZ: 20,
  XK: 20,
  KW: 30,
  LV: 21,
  LB: 28,
  LI: 21,
  LT: 20,
  LU: 20,
  MK: 19,
  MG: 27,
  ML: 28,
  MT: 31,
  MR: 27,
  MU: 30,
  MD: 24,
  MC: 27,
  ME: 22,
  MA: 28,
  MZ: 25,
  NL: 18,
  NI: 32,
  NE: 28,
  NO: 15,
  PK: 24,
  PS: 29,
  PL: 28,
  PT: 25,
  QA: 29,
  RO: 24,
  LC: 32,
  SM: 27,
  ST: 25,
  SA: 24,
  SN: 28,
  RS: 22,
  SC: 31,
  SK: 24,
  SI: 19,
  ES: 24,
  SE: 24,
  CH: 21,
  TL: 23,
  TG: 28,
  TN: 24,
  TR: 26,
  UA: 29,
  AE: 23,
  GB: 22,
}

export const REGEX_OGS_ZIP_CODE = new RegExp('^[0-9]{4,5}$', 'i')

// see source\js-ogs\vendor\jquery-plugins\jquery.validationEngine-en.js
export const REGEX_OGS_EMAIL = new RegExp(
  // eslint-disable-next-line no-control-regex
  "^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\\d|-|\\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\\d|-|\\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\\.?$"
)

export const REGEX_OGS_PASSWORD = new RegExp(
  '.*^(?=^.{8,32}$)(?=(?:.*?[\\\\§\\/!@#$%*\\[\\]<>()"_=+^&}{:;,°~?.-]){1})(?=(?:.*?[0-9]){1})(?=(?:.*?[a-zäöüß]){1})(?=(?:.*?[A-ZÄÖÜ]){1}).*$'
)

export const REGEX_OGS_INSURED_NUMBER = new RegExp('^.{10,12}$', 'i')

export const REGEX_URL = new RegExp(
  /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i
)

//------------------------------------*\
// #Datepicker
//------------------------------------*/
/*
declare const TYPO3: any

export const MONTH_NAMES = [
  TYPO3.lang.datepicker_month_jan,
  TYPO3.lang.datepicker_month_feb,
  TYPO3.lang.datepicker_month_mar,
  TYPO3.lang.datepicker_month_apr,
  TYPO3.lang.datepicker_month_may,
  TYPO3.lang.datepicker_month_jun,
  TYPO3.lang.datepicker_month_jul,
  TYPO3.lang.datepicker_month_aug,
  TYPO3.lang.datepicker_month_sep,
  TYPO3.lang.datepicker_month_oct,
  TYPO3.lang.datepicker_month_nov,
  TYPO3.lang.datepicker_month_dec,
]

export const MONTH_NAMES_SHORT = [
  TYPO3.lang.datepicker_month_jan,
  TYPO3.lang.datepicker_month_feb,
  TYPO3.lang.datepicker_month_mar,
  TYPO3.lang.datepicker_month_apr,
  TYPO3.lang.datepicker_month_may,
  TYPO3.lang.datepicker_month_jun,
  TYPO3.lang.datepicker_month_jul,
  TYPO3.lang.datepicker_month_aug,
  TYPO3.lang.datepicker_month_sep,
  TYPO3.lang.datepicker_month_oct,
  TYPO3.lang.datepicker_month_nov,
  TYPO3.lang.datepicker_month_dec,
]

export const DAY_NAMES = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']

export const DAY_NAMES_SHORT = [
  TYPO3.lang.datepicker_day_so,
  TYPO3.lang.datepicker_day_mo,
  TYPO3.lang.datepicker_day_tu,
  TYPO3.lang.datepicker_day_we,
  TYPO3.lang.datepicker_day_th,
  TYPO3.lang.datepicker_day_fr,
  TYPO3.lang.datepicker_day_sa,
]

export const DAY_NAMES_MIN = [
  TYPO3.lang.datepicker_day_so,
  TYPO3.lang.datepicker_day_mo,
  TYPO3.lang.datepicker_day_tu,
  TYPO3.lang.datepicker_day_we,
  TYPO3.lang.datepicker_day_th,
  TYPO3.lang.datepicker_day_fr,
  TYPO3.lang.datepicker_day_sa,
]*/
/* eslint-enable */